import { useEffect, useRef } from "react";
import gsap from "gsap";

export function Preloader({ onComplete }) {
  const containerRef = useRef(null);
  const logoRef = useRef(null);
  const textKRef = useRef(null);
  const textDentalRef = useRef(null);
  const glowRef = useRef(null);
  const taglineRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline({
      onComplete: () => {
        if (onComplete) onComplete();
      },
    });

    // Initial states
    gsap.set(logoRef.current, { scale: 0, opacity: 0, rotation: -10 });
    gsap.set(textKRef.current, { y: 30, opacity: 0 });
    gsap.set(textDentalRef.current, { y: 30, opacity: 0 });
    gsap.set(glowRef.current, { scale: 0.5, opacity: 0 });
    gsap.set(taglineRef.current, { y: 15, opacity: 0 });

    // 1. Glow appears
    tl.to(glowRef.current, {
      scale: 1,
      opacity: 0.6,
      duration: 0.5,
      ease: "power2.out",
    });

    // 2. Logo scales in with spring
    tl.to(
      logoRef.current,
      {
        scale: 1,
        opacity: 1,
        rotation: 0,
        duration: 0.7,
        ease: "back.out(1.7)",
      },
      "-=0.3"
    );

    // 3. "K" fades up
    tl.to(
      textKRef.current,
      {
        y: 0,
        opacity: 1,
        duration: 0.4,
        ease: "power3.out",
      },
      "-=0.2"
    );

    // 4. "Dental" fades up
    tl.to(
      textDentalRef.current,
      {
        y: 0,
        opacity: 1,
        duration: 0.4,
        ease: "power3.out",
      },
      "-=0.2"
    );

    // 5. Tagline fades in
    tl.to(
      taglineRef.current,
      {
        y: 0,
        opacity: 1,
        duration: 0.35,
        ease: "power2.out",
      },
      "-=0.1"
    );

    // 6. Glow pulse
    tl.to(glowRef.current, {
      scale: 1.3,
      opacity: 0.3,
      duration: 0.4,
      ease: "power2.inOut",
      yoyo: true,
      repeat: 1,
    });

    // 7. Hold briefly
    tl.to({}, { duration: 0.2 });

    // 8. Everything slides up and fades out
    tl.to(containerRef.current, {
      y: "-100%",
      opacity: 0,
      duration: 0.6,
      ease: "power3.inOut",
    });

    return () => tl.kill();
  }, [onComplete]);

  return (
    <div className="preloader" ref={containerRef}>
      <div className="preloader-content">
        <div className="preloader-glow" ref={glowRef} />
        <div className="preloader-logo" ref={logoRef}>
          <img src="/logo.png" alt="K Dental" />
        </div>
        <div className="preloader-text">
          <span className="preloader-k" ref={textKRef}>
            K
          </span>
          <span className="preloader-dental" ref={textDentalRef}>
            Dental
          </span>
        </div>
        <div className="preloader-tagline" ref={taglineRef}>
          India's Premier Dental Supply Platform
        </div>
      </div>
    </div>
  );
}
